import { AppCard, AppCardBody, AppText, kindredFontFamilies } from "../../ui-foundation";
import {
  DocumentList,
  DocumentPageScaffold,
  DocumentSection,
} from "@/components/DocumentScaffold";
import {
  KINDRED_SUPPORT_EMAIL,
  STEADY_HOUSE_SUPPORT_URL,
} from "../../shared/support";

const PrivacyFrench = () => {
  return (
    <DocumentPageScaffold
      title="Politique de confidentialité"
      updatedLabel="Dernière mise à jour : juillet 2026"
      fallbackPath="/"
      footerLinks={[
        { href: "/privacy", label: "English privacy" },
        { href: "/terms-fr", label: "Conditions d'utilisation" },
        { href: "/contact-complaints", label: "Contact & complaints" },
      ]}
    >
      <DocumentSection title="1. Ce que nous recueillons">
        <DocumentList
          items={[
            "Les détails de compte comme l'adresse e-mail et les données d'authentification chiffrées.",
            "Les informations de profil que vous choisissez de partager, comme votre nom d'affichage, votre pays, votre code postal ou code de localité, votre bio et votre photo.",
            "Le contenu que vous publiez dans Kindred, y compris les posts, réponses, messages, salons, activités et événements.",
            "Les données opérationnelles et de modération nécessaires pour faire fonctionner le service et assurer la sécurité de la communauté.",
          ]}
        />
      </DocumentSection>

      <DocumentSection title="2. Comment Kindred utilise vos données">
        <DocumentList
          items={[
            "Pour créer et gérer votre compte.",
            "Pour faire fonctionner les fonctions communautaires de l'application.",
            "Pour aider les membres à trouver une personne à identifier : une adresse e-mail exacte ou le nom associé au compte peut être recherché de manière privée, tandis que les suggestions affichent uniquement le nom d'affichage public et la photo de profil.",
            "Pour envoyer des communications de service, d'accueil, de sécurité ou d'assistance.",
            "Pour protéger les membres, examiner les signalements, prévenir les abus et respecter les obligations légales.",
          ]}
        />
      </DocumentSection>

      <DocumentSection title="3. Partage, transferts et conservation">
        <DocumentList
          items={[
            "Les autres membres ne voient que les informations et contenus que vous choisissez de partager dans l'application.",
            "Kindred utilise des prestataires comme Supabase, Resend et n8n pour exploiter le service selon ses instructions.",
            "Kindred ne vend pas les données personnelles et ne les partage pas avec des tiers pour leur propre publicité ou marketing.",
            "Les données peuvent être traitées au Royaume-Uni, dans l'EEE ou dans d'autres pays avec des garanties contractuelles, organisationnelles ou techniques appropriées.",
            "Les demandes de suppression, les incidents, les plaintes et certains dossiers de modération peuvent être conservés pendant une période limitée pour la sécurité, la responsabilité et la conformité.",
          ]}
        />
      </DocumentSection>

      <DocumentSection title="4. Vos droits et votre contact">
        <AppText>
          Selon votre pays ou province, vous pouvez avoir des droits d&apos;accès, de correction, de
          suppression, d&apos;opposition, de plainte ou d&apos;appel.
        </AppText>
        <AppText>
          Le lancement du Canada est actuellement en pause pendant que Kindred prépare une couche publique,
          juridique et d&apos;assistance correcte pour le Québec et le français. Cette page française reste
          disponible à titre de référence uniquement et ne signifie pas que le Canada est un marché actif ou
          imminent.
        </AppText>
        <AppText>
          Pour toute demande formelle ou plainte relative à la vie privée, utilisez{" "}
          <a
            href={STEADY_HOUSE_SUPPORT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="kindred-inline-link"
          >
            la page d&apos;assistance Steady House
          </a>{" "}
          ou écrivez{" "}
          <a href={`mailto:${KINDRED_SUPPORT_EMAIL}`} className="kindred-inline-link">
            {KINDRED_SUPPORT_EMAIL}
          </a>
          .
        </AppText>
      </DocumentSection>

      <AppCard backgroundColor="$panelBackground">
        <AppCardBody alignItems="center">
          <AppText
            textAlign="center"
            fontFamily={kindredFontFamilies.sansBold}
            fontSize="$md"
            lineHeight="$md"
          >
            Cette version française reste une référence de travail pendant que le lancement du Canada est
            en pause.
          </AppText>
        </AppCardBody>
      </AppCard>
    </DocumentPageScaffold>
  );
};

export default PrivacyFrench;
